import apiClient from "./apiClient";
import { normalizeApiError } from "../utils/apiError";

function toArray(value) {
  return Array.isArray(value) ? value : [];
}

function extractData(payload) {
  return payload?.data ?? payload;
}

const lotService = {
  async getLots(params = {}) {
    try {
      const cleanParams = Object.entries(params).reduce((acc, [key, value]) => {
        if (value !== "" && value !== null && value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {});

      const response = await apiClient.get("/lot", {
        params: cleanParams,
      });

      const payload = response?.data || {};
      const dataRoot = extractData(payload);
      const items = toArray(dataRoot?.data || dataRoot?.items || dataRoot);
      const meta = dataRoot?.meta || payload?.meta || {};

      return {
        items,
        meta: {
          page: Number(meta?.page || cleanParams.page || 1),
          limit: Number(meta?.limit || cleanParams.limit || 10),
          total: Number(meta?.total || meta?.totalItems || items.length || 0),
          totalPages: Number(meta?.totalPages || 1),
        },
        raw: payload,
      };
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async getActiveLots(params = {}) {
    try {
      const response = await apiClient.get("/lot/active", { params });
      const payload = response?.data || {};
      const data = extractData(payload);
      return {
        items: toArray(data),
        raw: payload,
      };
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async getLotById(id) {
    if (!id) throw new Error("Lot ID is required");

    try {
      const response = await apiClient.get(`/lot/${id}`);
      const payload = response?.data || {};
      return extractData(payload);
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async createLot(data) {
    try {
      const response = await apiClient.post("/lot", data);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async updateLot(id, data) {
    if (!id) throw new Error("Lot ID is required");

    try {
      const response = await apiClient.patch(`/lot/${id}`, data);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async deleteLot(id) {
    if (!id) throw new Error("Lot ID is required");

    try {
      const response = await apiClient.delete(`/lot/${id}`);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async getLotStockSummary(lotId) {
    try {
      const params = lotId ? { lotId } : {};
      const response = await apiClient.get("/lot/stock-summary", { params });
      const payload = response?.data || {};
      const data = extractData(payload);
      return toArray(data);
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async getStockSummaryByCategory(stockCategoryId, endDate) {
    try {
      const params = {};
      if (stockCategoryId) params.stockCategoryId = stockCategoryId;
      if (endDate) params.endDate = endDate;
      const response = await apiClient.get("/lot/stock-summary-by-category", { params });
      const payload = response?.data || {};
      const data = extractData(payload);
      return toArray(data);
    } catch (error) {
      throw normalizeApiError(error);
    }
  },
};

export default lotService;
